import { colors } from 'theme'

export const defaultThemeStyles: { textMain: string; textSub: string } = {
    textMain: colors.black,
    textSub: colors.grey,
}
